<template>
  <div style="width: 100%; height: 100vh">
    <iframe
      v-if="urlIframeBoleto"
      :src="urlIframeBoleto"
      frameborder="0"
      style="
        width: calc(100% - 60px);
        height: calc(100% - 50px);
        margin-left: 60px;
        margin-top: 50px;
      "
    ></iframe>

    <div
      v-else-if="urlIframeBoleto === ''"
      style="
        width: calc(100% - 60px);
        height: 100%;
        margin-left: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      "
    >
      <p
        style="
          color: black;
          font-size: 1.5rem;
          font-weight: 600;
          font-family: Poppins-Medium, sans-serif !important;
          margin: 0;
        "
      >
        Boleto indisponível no momento!
      </p>

      <p
        style="
          color: #666360;
          font-size: 0.8rem;
          font-weight: 500;
          font-family: Poppins-Medium, sans-serif !important;
          margin: 0;
        "
      >
        Para mais informações entre em contato com o grupo BMS.
      </p>
    </div>

    <div v-else class="boleto-loading" aria-label="Carregando boletos">
      <b-spinner variant="primary" label="Carregando" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState([
      "urlIframeBoleto",
      "dataCompany",
      "companyDataLoaded",
      "dataPlan",
      "planDataLoaded",
    ]),
    allowsBoleto() {
      const integrations = this.parseIntegrations(
        this.dataCompany?.liberars?.[0]?.integracoes
      );
      const boletos = integrations?.boletos || [];

      return Boolean(
        boletos.find((boleto) => boleto.text?.toUpperCase() === "SICOOB")?.value
      );
    },
    canAccessBoleto() {
      return (
        this.dataPlan.ativo &&
        this.dataPlan.tipoPlano !== "gestao_simples" &&
        this.allowsBoleto
      );
    },
    accessDataLoaded() {
      return this.companyDataLoaded && this.planDataLoaded;
    },
  },
  methods: {
    parseIntegrations(integrations) {
      if (typeof integrations !== "string") return integrations;

      try {
        return JSON.parse(integrations);
      } catch {
        return null;
      }
    },
  },
  watch: {
    accessDataLoaded: {
      immediate: true,
      handler(loaded) {
        if (loaded && !this.canAccessBoleto) {
          this.$router.replace({ path: "/home" });
        }
      },
    },
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    document.body.style.overflow = "auto";
  },
};
</script>

<style scoped>
.boleto-loading {
  width: calc(100% - 60px);
  height: 100%;
  margin-left: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
